import React, { Component } from 'react'
import { HBBModal } from '../../../Modal/Components'
import { MoveKitchenClusterModalLayout } from '../MoveKitchenClusterModalLayout'

class MoveKitchenCluster extends Component {
    constructor() {
        super()
        this.state = {
            isImportMoveKitchenClusterModalOpened: false,
        }
    }
    openImportMoveKitchenClusterModal = () => {
        this.setState({ isImportMoveKitchenClusterModalOpened: true })
    }

    controlOpenCloseOfModal = (status) => {
       this.setState({ isImportMoveKitchenClusterModalOpened: status })
    }

    refreshOrderList = () => {
        this.props.refreshOrderList()
    }

    render() {
        let modalComponent = null

        if (this.state.isImportMoveKitchenClusterModalOpened) {
            modalComponent =
                <HBBModal>
                    <MoveKitchenClusterModalLayout data={this.props.data}
                        closeModal={this.controlOpenCloseOfModal}
                        />
                </HBBModal>
        }
        return (
            <div>
                {modalComponent}
                <button
                    className="btn btn-primary button-custom button-custom-edit"
                     onClick={(e) => {
                        e.preventDefault()
                        this.openImportMoveKitchenClusterModal()
                    }}>
                    Move Kitchen
                </button>
            </div>
        )
    }
}

export default MoveKitchenCluster


// WEBPACK FOOTER //
// ./src/modules/Clusters/Components/ActionButtons/MoveKitchenCluster.js